import {
  faro,
  getWebInstrumentations,
  initializeFaro,
} from "@grafana/faro-web-sdk";
import type { App } from "vue";
import { config } from "@/config";

// Browser logs and errors go to Grafana Frontend Observability (Faro).
// Faro starts only when config.faroUrl has a collector URL for the current VUE_APP_ENV.
export const initFaro = (app: App) => {
  if (!config.faroUrl) return;

  initializeFaro({
    url: config.faroUrl,
    app: {
      name: "joystick-admin-ui",
      version: config.appVersion,
      environment: config.appEnv,
    },
    instrumentations: [...getWebInstrumentations()],
    // Happens on configversions.vue and spams the logs.
    ignoreErrors: [/ResizeObserver loop/],
  });

  // The unpatched console keeps the error visible in the browser without Faro reporting it twice.
  app.config.errorHandler = (err, _instance, info) => {
    faro.api.pushError(err instanceof Error ? err : new Error(String(err)), {
      context: { vueInfo: info },
    });
    faro.unpatchedConsole.error(err);
  };
};
